$(function () {
    var scroll_limit = 0;
    var new_scroll = 0;
    var h_window = $(window).height();

    $(document).on('click', '.footer__backtotop', function (e) {
        window.scrollTo({top: 0, behavior: 'smooth'});
    });

    function toggleArrowTop() {
        if (scroll_limit > (h_window * 1.25) && new_scroll >= (h_window * 1.25)) {
            $('.footer__backtotop').removeClass('hidden');
        } else {
            $('.footer__backtotop').addClass('hidden');
        }
    }

    toggleArrowTop();

    $(document).on('scroll', function () {
        scroll_limit = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
        new_scroll = $(document).scrollTop();

        toggleArrowTop();
    });
});
